import React, { useEffect, useState } from "react"
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Table,
} from "reactstrap"
import Breadcrumb from "components/Common/Breadcrumb"
import Logo from "../../assets/images/logo.png"
import {
  FaChevronLeft,
  FaChevronRight,
  FaPen,
  FaTrash,
  FaPlus,
  FaDownload,
  FaEye,
} from "react-icons/fa6"
import moment from "moment"
import Select from "react-select"
import { customStyles } from "utils/SelectStyles"
import {
  fetchData,
  FetchDeleteData,
  FetchPostData,
  FetchPutData,
} from "utils/Common_api_functions"
import Swal from "sweetalert2"
import Loader from "components/Loader/loader"
import Configs from "../../config"

const activities = [
  { name: "Run" },
  { name: "Bike" },
  { name: "Swim" },
  { name: "Brick" },
  { name: "Crosstrain" },
  { name: "Day off" },
  { name: "Mtn Bike" },
  { name: "Strength" },
  { name: "Custom" },
  { name: "XC-Ski" },
  { name: "Walk" },
  { name: "Other" },
]

const activityOptions = [
  { value: "", label: "All Activities" },
  ...activities.map(act => ({ value: act.name, label: act.name })),
]

const LeagueIndex = () => {
  const [loading, setloading] = useState(false)

  const [searchString, setSearchString] = useState("")

  const [leagues, setLeagues] = useState([])
  const [selectedLeague, setselectedLeague] = useState({})
  const [data, setData] = useState([])
  const [clubData, setClubData] = useState([])
  const [seasonData, setSeasonData] = useState([])
  const [selectedActivity, setSelectedActivity] = useState("")
  const [page, setPage] = useState(1)
  const [itemsPerPage] = useState(10)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [editingLeague, setEditingLeague] = useState(null)
  const [formData, setFormData] = useState({
    leagueName: "",
    season: "",
    startDate: "",
    endDate: "",
    clubs: [],
  })

  useEffect(() => {
    getData()
    getDropdownData()
  }, [])

  useEffect(() => {
    const fetchClubs = async () => {
      console.log(formData?.startDate, formData?.endDate)
      if (formData?.startDate && formData?.endDate) {
        const APIData = await FetchPostData(setloading, "club/with/filter", {
          startDate: formData?.startDate,
          endDate: formData?.endDate,
          leagueId: editingLeague?._id,
        })

        if (APIData?.data?.success) {
          const clubOptions = APIData?.data?.data?.map(item => ({
            value: item._id,
            label: item.clubName,
          }))
          setClubData(clubOptions)
        }
      }
    }

    fetchClubs()
  }, [formData?.startDate, formData?.endDate])

  async function getData() {
    const APIData = await fetchData(setloading, "league")
    if (APIData?.success) {
      setLeagues(APIData?.leagues)
      setData(APIData?.leagues)
    }
  }

  useEffect(() => {
    if (searchString !== "") {
      const filteredData = data.filter(item =>
        item.leagueName.toLowerCase().includes(searchString.toLowerCase())
      )
      setLeagues(filteredData)
      setPage(1)
    } else {
      setLeagues(data)
    }
  }, [searchString, data])

  async function getDropdownData() {
    const APIData = await fetchData(setloading, "season")
    const APIData2 = await fetchData(setloading, "club")

    const seasonOptions =
      APIData?.seasons?.map(item => ({
        value: item._id,
        label: item.seasonName,
      })) || []

    setSeasonData(seasonOptions)
  }

  const [viewLeague, setViewLeague] = useState(null)
  const totalPages = Math.ceil(leagues.length / itemsPerPage)
  const finalData = leagues.slice(
    (page - 1) * itemsPerPage,
    page * itemsPerPage
  )

  const changePage = pageNumber => {
    if (pageNumber > 0 && pageNumber <= totalPages) {
      setPage(pageNumber)
      window.scrollTo(0, 0)
    }
  }

  const handleInputChange = e => {
    const { name, value } = e.target
    setFormData({ ...formData, [name]: value })
  }

  const handleAddLeague = () => {
    setEditingLeague(null)
    setFormData({
      leagueName: "",
      season: "",
      startDate: "",
      endDate: "",
      clubs: [],
    })
    setIsModalOpen(true)
  }

  const handleEditLeague = league => {
    setEditingLeague(league)
    setFormData({
      leagueName: league?.leagueName,
      season: league?.season?._id,
      startDate: league?.startDate,
      endDate: league?.endDate,
      clubs: league?.clubs?.map(c => c._id),
    })
    setIsModalOpen(true)
  }

  const handleDeleteLeague = id => {
    Swal.fire({
      title: "Are you sure?",
      text: "This action will permanently delete the League.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then(async result => {
      if (result.isConfirmed) {
        const APIData = await FetchDeleteData(setloading, "league", id)

        if (APIData?.data?.success) {
          Swal.fire({
            title: "League Deleted Successfully",
            icon: "success",
          })
          getData()
        } else {
          Swal.fire({
            title: "Something Went Wrong",
            text: APIData?.response?.data?.message,
            icon: "error",
          })
        }
      }
    })
  }

  const handleSubmit = async e => {
    e.preventDefault()
    if (editingLeague) {
      const APIData = await FetchPutData(
        setloading,
        "league",
        editingLeague._id,
        formData
      )

      if (APIData?.data?.success) {
        Swal.fire({
          icon: "success",
          title: "League Updated Successfully",
        })
      } else {
        Swal.fire({
          icon: "error",
          title: "Something went wrong",
        })
      }
      getData()
    } else {
      const APIData = await FetchPostData(setloading, "league", formData)

      if (APIData?.data?.success) {
        Swal.fire({
          icon: "success",
          title: "League Added Successfully",
        })
      } else {
        Swal.fire({
          icon: "error",
          title: "Something went wrong",
        })
      }
      getData()
    }
    setIsModalOpen(false)
  }

  // const handleExport = async league => {
  //   const APIdata = await fetchData(setloading, `league/export/${league._id}`)

  //   if (APIdata?.data) {
  //     // 2️⃣ Expect CSV or JSON
  //     if (!response.ok) throw new Error("Failed to export CSV")

  //     const blob = await response.blob()
  //     const url = window.URL.createObjectURL(blob)

  //     // 3️⃣ Trigger download
  //     const link = document.createElement("a")
  //     link.href = url
  //     link.download = `${league.leagueName || "league"}-export.csv`
  //     document.body.appendChild(link)
  //     link.click()
  //     link.remove()

  //     window.URL.revokeObjectURL(url)
  //   } else {
  //     Swal.fire({
  //       title: "Something Went Wrong",
  //       text: APIdata?.response?.data?.message,
  //       icon: "error",
  //     })
  //   }
  // }

  const handleExport = league => {
    // Construct the full API URL
    const url = `${Configs.baseURL}league/export/${league._id}`

    // Open in a new tab
    window.open(url, "_blank")
  }

  const handleLeagueView = async leagueId => {
    const APIdata = await fetchData(
      setloading,
      `league/leaderboard/${leagueId}`
    )

    if (APIdata?.success) {
      setselectedLeague(APIdata)
      setViewLeague(true)
    }
  }

  return (
    <div className="page-content">
      {loading && <Loader />}
      <Container fluid>
        <Breadcrumb title="" breadcrumbItem="League Management" />

        <Row>
          <Col lg="12">
            <Card>
              <CardBody>
                <div className="d-flex justify-content-between align-items-center">
                  <h4 className="text-black fw-bold ps-1 mb-0">Leagues</h4>
                  <div className="d-flex gap-3">
                    <div className="form-group">
                      <Input
                        placeholder="Search Leagues"
                        value={searchString}
                        onChange={e => setSearchString(e.target.value)}
                      />
                    </div>
                    {/* <div style={{ minWidth: "200px" }}>
                      <Select
                        options={activityOptions}
                        value={activityOptions.find(
                          opt => opt.value === selectedActivity
                        )}
                        onChange={opt => setSelectedActivity(opt?.value || "")}
                        placeholder="Filter by Activity"
                        isClearable
                        styles={customStyles}
                      />
                    </div> */}
                    <Button className="btn btn-add" onClick={handleAddLeague}>
                      <FaPlus className="me-1" /> Add League
                    </Button>
                  </div>
                </div>

                <div className="mt-3">
                  <Table responsive bordered className="rounded-3">
                    <thead className="table-primary text-dark">
                      <tr>
                        <th>Sr No.</th>
                        <th>League Name</th>
                        <th>Season</th>
                        <th>Start Date</th>
                        <th>End Date</th>
                        <th>Clubs</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {finalData.map((league, index) => {
                        return (
                          <tr key={league.id}>
                            <td>{(page - 1) * itemsPerPage + index + 1}</td>
                            <td>{league.leagueName}</td>
                            <td>{league?.season?.seasonName || "N/A"}</td>
                            <td>
                              {moment(league.startDate).format("DD-MM-YYYY")}
                            </td>
                            <td>
                              {moment(league.endDate).format("DD-MM-YYYY")}
                            </td>
                            <td style={{ maxWidth: "270px" }}>
                              {league.clubs.map(c => c.clubName).join(", ")}
                            </td>
                            <td>
                              {/* <button
                                className="btn btn-sm btn-outline-primary me-2"
                                onClick={() => handleExport(league)}
                              >
                                <FaDownload size={12} />
                              </button> */}
                              <button
                                className="btn btn-sm btn-outline-primary me-2"
                                onClick={() => {
                                  handleLeagueView(league?._id)
                                }}
                              >
                                <FaEye size={12} />
                              </button>
                              <button
                                className="btn btn-sm btn-outline-secondary me-2"
                                onClick={() => handleEditLeague(league)}
                              >
                                <FaPen size={12} />
                              </button>
                              <button
                                className="btn btn-sm btn-outline-danger"
                                onClick={() => handleDeleteLeague(league._id)}
                              >
                                <FaTrash size={12} />
                              </button>
                            </td>
                          </tr>
                        )
                      })}
                      {finalData.length === 0 && (
                        <tr>
                          <td colSpan={7} className="text-center">
                            No Data Found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>

                <div className="d-flex justify-content-between align-items-center my-2 px-2">
                  <p className="mb-0">
                    Showing {finalData.length} out of {leagues.length} Leagues.
                  </p>
                  <div className="d-flex flex-wrap">
                    <div
                      className="bd-number-pagination me-1"
                      onClick={() => changePage(page - 1)}
                      style={{ cursor: "pointer" }}
                    >
                      <FaChevronLeft />
                    </div>
                    {[...Array(totalPages)].map((_, i) => {
                      const pageIndex = i + 1
                      return (
                        <div
                          key={pageIndex}
                          className={`bd-number-pagination me-1 ${
                            page === pageIndex ? "activepage" : ""
                          }`}
                          onClick={() => changePage(pageIndex)}
                          style={{ cursor: "pointer" }}
                        >
                          {pageIndex < 10 ? "0" + pageIndex : pageIndex}
                        </div>
                      )
                    })}
                    <div
                      className="bd-number-pagination"
                      onClick={() => changePage(page + 1)}
                      style={{ cursor: "pointer" }}
                    >
                      <FaChevronRight />
                    </div>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>

      {/* Add/Edit Modal */}
      <Modal
        isOpen={isModalOpen}
        toggle={() => setIsModalOpen(!isModalOpen)}
        centered
        size="lg"
      >
        <ModalHeader toggle={() => setIsModalOpen(!isModalOpen)}>
          {editingLeague ? "Edit League" : "Add League"}
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={handleSubmit}>
            <FormGroup>
              <Label>
                League Name <span className="text-danger">*</span>
              </Label>
              <Input
                type="text"
                name="leagueName"
                value={formData.leagueName}
                onChange={handleInputChange}
                required
              />
            </FormGroup>
            <FormGroup>
              <Label>
                Season <span className="text-danger">*</span>
              </Label>
              <Input
                type="select"
                name="season"
                value={formData.season}
                onChange={handleInputChange}
                required
              >
                <option value="">-- Select Season --</option>
                {seasonData?.map(s => (
                  <option key={s.id} value={s.value}>
                    {s.label}
                  </option>
                ))}
              </Input>
            </FormGroup>
            <Row>
              <Col md={6}>
                <FormGroup>
                  <Label>
                    Start Date <span className="text-danger">*</span>
                  </Label>
                  <Input
                    type="date"
                    name="startDate"
                    value={moment(formData.startDate).format("YYYY-MM-DD")}
                    onChange={handleInputChange}
                    required
                  />
                </FormGroup>
              </Col>
              <Col md={6}>
                <FormGroup>
                  <Label>
                    End Date <span className="text-danger">*</span>
                  </Label>
                  <Input
                    type="date"
                    name="endDate"
                    value={moment(formData.endDate).format("YYYY-MM-DD")}
                    onChange={handleInputChange}
                    required
                  />
                </FormGroup>
              </Col>
            </Row>
            <FormGroup>
              <Label>Clubs</Label>
              <Select
                isMulti
                options={clubData}
                value={clubData.filter(opt =>
                  formData.clubs.includes(opt.value)
                )}
                onChange={opts =>
                  setFormData({
                    ...formData,
                    clubs: opts ? opts.map(o => o.value) : [],
                  })
                }
                placeholder="Select clubs..."
                styles={customStyles}
              />
            </FormGroup>

            <div className="text-end">
              <Button color="primary" type="submit">
                {editingLeague ? "Update" : "Add"}
              </Button>
              <Button
                color="danger"
                className="ms-2"
                onClick={() => setIsModalOpen(!isModalOpen)}
              >
                Cancel
              </Button>
            </div>
          </Form>
        </ModalBody>
      </Modal>

      {/* View Modal */}
      <Modal
        isOpen={!!viewLeague}
        toggle={() => setViewLeague(null)}
        centered
        size="xl"
      >
        <ModalHeader toggle={() => setViewLeague(null)}>
          League Standings - {selectedLeague?.leagueName}
        </ModalHeader>
        <ModalBody>
          <Table responsive bordered className="rounded-3">
            <thead className="table-dark text-white">
              <tr>
                <th>Position</th>
                <th>Team</th>
                <th>Fans</th>
                <th>Activities</th>
                <th>Distance</th>
                <th>Points</th>
                <th>parkrun points</th>
                <th>Average Points</th>
                <th>Total Points</th>
              </tr>
            </thead>
            <tbody>
              {selectedLeague &&
                selectedLeague?.data?.map((row, index) => (
                  <tr key={row.id}>
                    <td>{index + 1}</td>
                    <td>
                      <img
                        src={`${Configs?.imageurl}${row?.clubImage}`}
                        alt={row.team}
                        style={{ width: "30px", marginRight: "8px" }}
                      />
                      {row.clubName}
                    </td>
                    <td>{row.users}</td>
                    <td>{row.totalActivities}</td>
                    <td>{row.totalDistanceCovered}</td>
                    <td className="fw-bold">{row.points}</td>
                    <td className="fw-bold">{row.parkRunPoints}</td>
                    <th className="fw-bold">
                      {(row.totalPoints / row.users).toFixed(0) || 0}
                    </th>
                    <td className="fw-bold">{row.totalPoints}</td>
                  </tr>
                ))}
            </tbody>
          </Table>
        </ModalBody>
      </Modal>
    </div>
  )
}

export default LeagueIndex
